export const Testimonials = (props) => {
  return (
    <div id='testimonials'>
      <div className='container'>
        <div className='section-title text-center'>
          <h2>Preguntas Frecuentes</h2>
        </div>
        <div className='row'>
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className='col-md-6'>
                  <div className='testimonial '>
                    <div  className='testimonial-image'>
                    {' '}
                      <img src={d.img} alt='' />{' '}
                    </div> {' '}
                    <div className='testimonial-content'>
                      <p style={{ textAlign: 'center'}}><b>"{d.question}"</b></p>
                      <p style={{ textAlign: 'justify'}}> - {d.answer}</p>
                      {/* <div className='testimonial-meta'> - {d.name} </div> */}
                      <div>
                      {  i==0 
                      ?
                      <>
                      {/* <img src='img/testimonials/laminaVidrio.jpg' alt='Vidrios Laminados.' style={{width: "100%", height:"auto", marginTop:"0.8em",marginBottom:"2.5em", borderRadius : '10%'}} /> 
                      <a href="img/testimonials/direcciones.jpg">
                        <img src='img/testimonials/direcciones.jpg' alt='Direcciones para presentar los documentos originales.' style={{width: "100%", height:"auto",  borderRadius : '10%'}} href="img/testimonials/direcciones.jpg"/> 
                      </a> */}
                      </>
                      : ''   }
                      </div>
                    </div>
                  </div>
                </div>
              ))
            : 'loading'}
        </div>
        <div className='row col-md-12' style={{textAlign:"center"}}>
          <a href="img/testimonials/direcciones3.jpg">
            <img src='img/testimonials/direcciones3.jpg' alt='Direcciones para presentar los documentos originales.' style={{ width: "50%", height: "auto", borderRadius: '10%' }}/>
          </a>
        </div>
      </div>
    </div>
  )
}
